var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"position":"relative"}},[_c('v-row',{staticClass:"mt-4"},[_c('v-col',{attrs:{"cols":"4"}},[_c('HelpRA')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }